const ValidateName = (name) => {
    return name.length >= 2 && /^[a-zA-ZÀ-ỹ\s]+$/.test(name);
};

export default ValidateName